import { isEmptyArray } from '@srcDS/utils/assertions';

export const useCategoryMetadata = (data: any, stream: any, currentPage: any) => {
  const {
    categories,
    categoryTitle,
    categoryText,
    seoBlockTitle,
    seoBlockText,
    showReadmore,
    charLimit,
    stream: { projectSpecificData },
  } = data;

  const getTitleAndSubtitle = () => ({
    title: categoryTitle || '',
    subtitle: typeof categoryText ? '' : categoryText || '',
  });

  const getFeaturedCategories = () => {
    const filterFeatured = categories?.filter(
      (c: any) => (c.categoryAvatar && c.reference) || (c.title && c.reference),
    );
    return !filterFeatured || isEmptyArray(filterFeatured) ? null : filterFeatured;
  };

  const getSeoMetadata = () => ({
    title: seoBlockTitle || projectSpecificData?.bottomMetaTitle || currentPage?.configuration?.seoTitle || '',
    text:
      seoBlockText || projectSpecificData?.bottomMetaDescription || currentPage?.configuration?.seoDescription || '',
    showReadmore,
    charLimit,
  });

  return {
    getTitleAndSubtitle,
    getFeaturedCategories,
    getSeoMetadata,
  };
};
